import Vue from 'vue'
import VideoPlayer from './VideoPlayer.vue';

export default {
  show(url) {
    const ComponentClass = Vue.extend(VideoPlayer); // 创建一个Vue的扩展实例构造函数
    const instance = new ComponentClass({
      el: document.createElement('div'), // 创建一个新的DOM元素作为挂载点
      data: {
        url: url
      }
    });
    document.body.appendChild(instance.$el); // 将这个DOM元素添加到body或其他DOM元素中
  },
};